import { Category, ICategoryArgs } from "../category/category.model";

export interface ITaskTypeArgs extends ICategoryArgs {

}

export class TaskType extends Category {

    constructor(data?: ITaskTypeArgs) {
        super(data);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task-type/task-type.model.ts